import { trackEvent } from "../../services/firebase";
import { APPLY_LINK, ApplyButton, IconCircle } from "./shared";
import heroImage from "../../assets/home/hero-woman.jpg";
import glowTop from "../../assets/home/hero-glow-top.svg";
import glowTop2 from "../../assets/home/hero-glow-top2.svg";
import glowBottom from "../../assets/home/hero-glow-bottom.svg";
import heroEllipse from "../../assets/home/hero-ellipse.svg";
import iconRupee from "../../assets/home/icon-rupee.svg";
import iconUser from "../../assets/home/icon-user.svg";
import iconFile from "../../assets/home/icon-file.svg";

const PRICING = [
  { label: "Loan Amount", value: "₹5,000–₹50,000", icon: iconRupee },
  { label: "Repayment Tenure", value: "61–90 days", icon: iconUser },
  { label: "Interest Rate", value: "3% per 30-day period", icon: null },
  { label: "Processing Fee", value: "Up to 10%", icon: iconFile },
];

const BADGES = [
  { label: "Low Processing Fee (PF)", left: "62.5%", top: "11.2%" },
  { label: "For Salaried Professionals", left: "5.2%", top: "29.6%" },
  { label: "Low Interest Rates", left: "67.8%", top: "46.4%" },
  { label: "No prepayment charges", left: "17.4%", top: "62.7%" },
];

export default function HomeHero() {
  return (
    <section className="bg-[#f8fafc] rounded-b-[40px] px-4 sm:px-6 lg:px-[80px] pt-[112px] sm:pt-[128px] lg:pt-[176px] pb-10 lg:pb-[72px]">
      <div className="relative max-w-[1280px] mx-auto overflow-hidden rounded-[28px] lg:rounded-[40px] border border-[#d7f3e8] bg-[#f5fffa] shadow-[0px_18px_48px_-16px_rgba(6,78,59,0.07)] px-5 sm:px-8 lg:px-[55px] pt-8 lg:pt-[66px] pb-8 lg:pb-[57px]">
        <div className="pointer-events-none absolute left-[-108px] top-[-136px] h-[444px] w-[454px]">
          <div className="absolute inset-[-40.54%_-39.65%]">
            <img alt="" className="block max-w-none size-full" src={glowTop} />
          </div>
        </div>
        <div className="pointer-events-none absolute left-[944px] top-[447px] size-[360px]">
          <div className="absolute inset-[-50%]">
            <img alt="" className="block max-w-none size-full" src={glowTop2} />
          </div>
        </div>
        <div className="pointer-events-none absolute left-[1013px] top-[461px] size-[420px]">
          <div className="absolute inset-[-52.38%]">
            <img alt="" className="block max-w-none size-full" src={glowBottom} />
          </div>
        </div>

        <div className="relative flex flex-col lg:flex-row lg:items-start lg:justify-between gap-8 lg:gap-6">
          <h1 className="lg:w-[580px] lg:pt-[38px] font-bold text-black text-[38px] sm:text-[48px] lg:text-[60px] leading-[1.25] lg:leading-[91.275px] tracking-[-1.882px] lg:max-w-[467px] text-center lg:text-left">
            Instant Personal loan made for your needs
          </h1>

          <div className="relative w-full max-w-[534px] mx-auto lg:mx-0 lg:mt-[31px] shrink-0">
            <img alt="" src={heroEllipse} className="absolute left-0 top-[71.9%] w-full h-[24.3%] pointer-events-none" />
            <img
              src={heroImage}
              alt="Salaried professional working at a desk"
              loading="eager"
              fetchPriority="high"
              className="relative w-full aspect-[534/338] object-contain"
            />
            {BADGES.map((b) => (
              <span
                key={b.label}
                className="absolute hidden sm:flex bg-[#f8fafc] border-[0.806px] border-[rgba(91,22,140,0.5)] rounded-full px-[12.9px] py-[6.45px] font-extrabold text-[#5b168c] text-[9.676px] tracking-[0.9676px] uppercase whitespace-nowrap"
                style={{ left: b.left, top: b.top }}
              >
                {b.label}
              </span>
            ))}
          </div>
        </div>

        <p className="relative font-medium text-[#1a1a4b] text-[16px] sm:text-[18px] leading-[30px] mt-6 lg:mt-0 text-center lg:text-left">
          Lowest Rate Personal Loans Exclusively for Salaried Professionals
        </p>

        <div className="relative mt-6 lg:mt-[36px] bg-white border border-[#d7f3e8] rounded-[24px] p-[15px] drop-shadow-[0px_12px_14px_rgba(6,78,59,0.06)] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {PRICING.map((item) => (
            <div key={item.label} className="bg-[#f8fafc] border border-[#e5e7eb] rounded-[16px] p-[15px] lg:h-[95px]">
              <div className="flex items-center gap-2 h-8">
                <IconCircle size={32}>
                  {item.icon ? (
                    <img alt="" src={item.icon} className="size-4" />
                  ) : (
                    <span className="font-light text-[#5b168c] text-[18px] leading-none">%</span>
                  )}
                </IconCircle>
                <span className="font-extrabold text-[#5b168c] text-[14px] tracking-[0.5px] uppercase whitespace-nowrap">
                  {item.label}
                </span>
              </div>
              <p className="mt-2 font-bold text-[#1a1a4b] text-[18px] whitespace-nowrap">{item.value}</p>
            </div>
          ))}
        </div>

        <div className="relative mt-6 flex flex-col sm:flex-row items-center gap-4">
          <a
            href={APPLY_LINK}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackEvent("check_eligibility_click", { location: "hero" })}
            className="inline-flex items-center justify-center h-[50px] w-full sm:w-[225px] border border-[#5c168a] rounded-full font-bold text-[#5c168a] text-[14px] tracking-[1px] uppercase whitespace-nowrap transition-colors hover:bg-[#5c168a]/5"
          >
            Check Eligibility
          </a>
          <ApplyButton label="Apply Now" location="hero" className="h-[50px] w-full sm:w-[194px]" />
        </div>
      </div>
    </section>
  );
}
